<template>
  <v-col cols="12">
    <v-list flat v-model="selectedItem" two-line subheader>
      <v-list-item-group v-model="selectedItem">
        <v-list-item v-for="(experience, i) in experiences" :key="i">
          <!-- avatar -->
          <v-list-item-avatar>
            <v-icon>mdi-briefcase</v-icon>
          </v-list-item-avatar>
          <!-- v-list item content -->
          <v-list-item-content>
            <v-list-item-title v-text="experience.label"></v-list-item-title>
            <v-list-item-subtitle v-html="rawHtml(experience)">
              <!-- <span class="font-weight-medium">à</span> -->
              <!-- <span class="font-weight-medium">{{experience.host }}</span> -->
              <!-- - {{experience.duration}} an
            <span v-if="experience.duration>1">(s)</span>
              <p>{{experience.expDescription}}</p>-->
            </v-list-item-subtitle>
          </v-list-item-content>
          <!-- v-list item actions -->
          <v-list-item-action>
            <v-btn icon @click="dialog=true">
              <v-icon color="grey lighten-1">mdi-delete</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <!-- before delete dialog -->
    <v-dialog v-model="dialog" persistent max-width="490">
      <v-card>
        <v-card-title class="title">Supprimer votre éxperience</v-card-title>
        <v-card-text>Vous êtes entrain de supprimer votre éxperience.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error darken-1" outlined @click="dialog = false">Annuler</v-btn>
          <v-btn text @click="onDeleteClicked">Je confirme</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
export default {
  props: ["experiences"],
  data() {
    return {
      dialog: false,
      updateDialog: false,
      selectedItem: null
    };
  },
  methods: {
    rawHtml(e) {
      return `à <span class="text--primary">${e.host}</span> - ${
        e.duration
      }  an ${e.duration > 1 ? "(s)" : ""}
      <p >${e.expDescription}</p>`;
    },
    onDeleteClicked() {
      this.$store.dispatch(
        "deleteExperience",
        this.experiences[this.selectedItem]._id
      );
      this.dialog = false;
    }
  }
};
</script>
